// i18n area 'backups' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.bg-BG.meta.json.
import type { enUS } from './backups'

export const bgBG: typeof enUS = {
  ckpt: {
    contents: 'Приема',
    contentsHint:
      'Какво може да кацне тук. „Checkpoints“ е конфигурацията на клъстера, „Резервни копия на данните“ са тези на ВМ: двете четения се съчетават, едно местоназначение може да приема и двете.',
    content: { checkpoints: 'Checkpoints', backups: 'Резервни копия на данните' },
    destinationsTitle: 'Дестинации за бекъп',
    checkpointsTitle: 'Чекпойнти',
    restoreTitle: 'Възстановяване',
    addDestination: 'Добави дестинация',
    addDestinationTitle: 'Добавяне на дестинация за бекъп',
    editDestinationTitle: 'Редактиране на дестинацията',
    storage: 'Хранилище',
    storageHint:
      'Dir-подобно хранилище (dir/NFS/CIFS/CephFS) — артефактите са обикновени файлове под именното пространство на платформата.',
    schedule: 'График',
    scheduleNone: 'Само ръчно',
    scheduleHourly: 'Всеки час',
    scheduleDaily: 'Всеки ден',
    scheduleWeekly: 'Всяка седмица',
    scheduleHour: 'Час',
    scheduleWeekday: 'Ден',
    scheduleHint:
      'Чекпойнтите по график нямат оператор, който да въведе мастер-паролата: секретите от хранилището за ключове се пакетират като плейсхолдъри.',
    retention: 'Задържане',
    retentionHint:
      'Колко чекпойнта по график да се пазят — метачът премахва най-старите над бройката. Ръчните и предвъзстановителните чекпойнти никога не се премахват.',
    paused: 'На пауза',
    pausedHint:
      'Блекаутът на оператора: докато е на пауза, на тази дестинация нищо не се планира и нищо не се подкастря — политики за данни и чекпойнти еднакво. Текущите изпълнения никога не се докосват.',
    orphanRuns: '{n} осиротели изпълнения',
    orphanRunsHint:
      'Планирани изпълнения на policy, които вече не съществуват на тази дестинация: никаква retention не ги управлява — никога броени, никога орязвани — и само ръка ги изтрива. Лещата „backups“ на tvirt diagnose назовава премахнатите policy.',
    rescan: 'Повторно приемане на артефактите',
    rescanTitle: 'Повторно приемане на артефактите на {name}',
    rescanHint:
      'Изгражда наново каталога на резервните копия (VM/CT/App) от манифестите на артефактите в дестинацията. Съществуващите редове никога не се докосват; копията на непознати политики остават сираци (никога не се подрязват автоматично). Ходът след bootstrap възстановяване.',
    masterpassDrWarning:
      'Сценарий на бедствие: LUKS дисковете се връщат САМО от checkpoint С masterpass. Планираните checkpoint-и пакетират заместители — правете периодично ръчен checkpoint с masterpass.',
    policy: {
      title: 'Политики за бекъп на данните',
      hint: 'Именувани политики: кои обекти (kind, тагове, скоупове), колко често, кога едно изпълнение може да тръгне и колко копия да се пазят. Жестът на записване остава у собственика на обекта: таговете се задават върху неговия собствен скоуп.',
      add: 'Добави политика',
      column: 'Политики за данни',
      name: 'Име',
      nameHint:
        'Етикет на policy, уникален в рамките на дестинацията. Изпълненията следват стабилното id на policy: преименуването е безплатно; изтриването осиротява изпълненията ѝ (вече не се броят, нито се орязват).',
      kindLocked: 'Семейството обекти на съществуваща policy не се променя: създайте нова policy.',
      kindLabel: 'Обекти',
      kind: { vm: 'Виртуални машини', ct: 'Контейнери', app: 'Приложения' },
      tags: 'Селектор по тагове',
      tagsHint:
        'Двойки tag=стойност, разделени със запетаи, в AND. Празни тагове и скоупове не избират нищо — никога „всичко“.',
      scopes: 'Скоупове',
      scopesHint: 'Пътища на скоупове (поддървета), разделени със запетаи, в OR помежду си.',
      windowStart: 'Прозорец от',
      windowEnd: 'Прозорец до',
      windowHint:
        'Прозорец на изпълнение (HH:MM, местно време; начало след края прекрачва полунощ). Управлява само СТАРТА: изпълнение, което го надхвърли, никога не се убива.',
      mode: 'Режим',
      modeHint: 'Инкременталният язди семейството от серии; скъсана серия деградира до full, казано в дневника.',
      modeFull: 'Full',
      modeIncremental: 'Инкрементален',
      requireQuiesce: 'Изисквай quiesce (guest agent)',
      paused: 'Политика на пауза',
      retentionNone: 'Пази всичко',
      retentionCount: 'Брой',
      retentionGfs: 'GFS пръстени',
      gfs: { keepLast: 'Последни', daily: 'Дневни', weekly: 'Седмични', monthly: 'Месечни', yearly: 'Годишни' },
      gfsHint:
        'За всеки пръстен се пази най-новото копие от всеки от последните N периода. Запазено копие държи жива цялата си верига — никога база със сираци.',
      lastRun: 'Последно изпълнение',
      neverRan: 'никога не е изпълнявано'
    },
    lastCheckpoint: 'Последен чекпойнт',
    neverRun: 'Никога не е създаван',
    createNow: 'Създай чекпойнт',
    createNowTitle: 'Създай чекпойнт — {name}',
    masterpass: 'Мастер-парола',
    masterpassHint:
      'Защитава секретните стойности в хранилището за ключове (argon2id → AES-256-GCM, за всяка стойност поотделно). Никога не се записва: пазете я — без нея едно възстановяване дава плейсхолдъри вместо истинските секрети.',
    masterpassEmptyHint: 'Оставете празно, за да се пакетират явни плейсхолдъри вместо секретите.',
    createStarted: 'Създаване на чекпойнт тече…',
    destinationInUseError: "'{name}' още съдържа чекпойнти — първо ги изтрийте.",
    origin: 'Произход',
    originManual: 'ръчен',
    originSchedule: 'по график',
    originPreRestore: 'предвъзстановителен',
    originPreChange: 'преди промяна',
    preChangeRetention: 'Чекпойнти преди промяна',
    preChangeRetentionHint:
      'Празно = изключено. Първият запис на конфигурация след период на затишие замразява тук предишното състояние (произход „преди промяна“); най-новите се пазят до броя — собствена, подрязваема ретенция.',
    diffTitle: 'Преглед на промените',
    diffFailed: 'Прегледът не успя',
    diffRetry: 'Опитай отново',
    diffCounts: '{changed} за промяна · {missing} за създаване · {extra} излишни · {equal} идентични',
    diffChanged: 'променя се',
    diffMissing: 'би било създадено',
    diffExtra: 'би било изтрито',
    diffJsonb: 'jsonb препратки, непроверими преди прилагането',
    diffSecret: 'запечатани полета, несравними',
    diffMore: 'още {n}…',
    diffNeeded: 'Стартът се активира, когато прегледът отразява избора.',
    phase: 'Състояние',
    phaseRunning: 'в изпълнение',
    phaseComplete: 'завършен',
    phaseError: 'грешка',
    secrets: 'Секрети',
    secretsMasterpass: 'мастер-парола',
    secretsPlaceholders: 'плейсхолдъри',
    size: 'Размер',
    created: 'Създаден',
    destination: 'Дестинация',
    download: 'Изтегли .tvbk',
    deleteCheckpoint: 'Изтрий чекпойнта',
    noCheckpoints: 'Няма чекпойнти — създайте един от някоя дестинация.',

    // Round #156 (dialog standard): la superficie di lettura completa del
    // record di archivio — righe di dettaglio per i campi mai mostrati in tabella.
    families: 'Семейства',
    generation: 'Поколение',
    completedAt: 'Завършен на',
    errorDetail: 'Детайл на грешката',
    manifest: 'Манифест',
    restoreHint:
      'Качете .tvbk артефакт: браузърът на съдържанието показва какво носи, после избирате какво да възстановите и как.',
    uploadFile: 'Качи .tvbk файл',
    uploading: 'Качване…',
    uploadFailed: 'Неуспешно отваряне на артефакта',
    explorerTitle: 'Съдържание на чекпойнта',
    checkpointFrom: 'Чекпойнт на клъстер {cluster}, създаден на {when} ({origin}, поколение {generation})',
    otherCluster: 'Този чекпойнт идва от ДРУГ клъстер ({cluster}) — възстановяването между клъстери идва в бъдещ рунд.',
    encrypted: 'шифрован',
    objectsCount: '{n} обекта',
    mode: 'Режим',
    modeMerge: 'Merge — съгласуване: upsert на избраните редове, нищо не се изтрива',
    modeOverwrite:
      'Overwrite — чекпойнтът печели: изцяло избрано семейство се заменя цялото (текущите редове, които липсват в чекпойнта, изчезват)',
    restoreMasterpassHint:
      'Мастер-паролата, с която е създаден чекпойнтът. Без нея шифрованите секрети се възстановяват като явни плейсхолдъри.',
    checkMasterpass: 'Провери',
    masterpassOk: 'Мастер-паролата е вярна',
    masterpassWrong: 'Грешна мастер-парола',
    parachuteDestination: 'Дестинация-парашут',
    parachuteHint:
      'Преди да докосне какъвто и да е ред, задачата създава тук автоматичен предвъзстановителен чекпойнт.',
    summaryTitle: 'Какво ще се случи',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'цялото семейство',
    summaryObjects: '{n} избрани обекта',
    confirmHint:
      'Въведете името на клъстера ({name}), за да потвърдите — възстановяването пренаписва декларираната конфигурация.',
    confirmField: 'Име на клъстера',
    startRestore: 'Възстанови',
    restoreRunning: 'Възстановяването тече…',
    restoreDone: 'Възстановяването завърши — съгласувателите се схождат към новата декларация.',
    restoreFailed: 'Възстановяването се провали',
    discard: 'Отхвърли',
    selectionEmpty: 'Изберете поне едно семейство или обект.'
  },

  backup: {
    intro: {
      title: 'Резервно копиране на данните на ВМ и контейнери',
      subtitle: 'Градивните блокове, които използва външният софтуер за резервни копия',
      whatItIs:
        'TVirt предоставя четири примитива: съгласувани (quiesced) снапшоти, проследяване на промените по всеки диск, NBD експорт само за четене и експорт на конфигурацията. Управляват ги Veeam, Bacula, Acronis и компания.',
      whatItIsNot:
        'TVirt не е продукт за резервни копия: не планира нищо, не прилага задържане и не пази никакъв архив на вашите данни. Задържането, каталозите и политиките за възстановяване остават в софтуера, който вече използвате.'
    },
    cbt: {
      title: 'Проследяване на промените',
      colVm: 'ВМ',
      colDisk: 'Диск',
      colState: 'Състояние',
      colBitmaps: 'Битмапи',
      colObservedAt: 'Наблюдавано',
      colChangeId: 'Change ID',
      colMechanic: 'Механизъм',
      stateActive: 'Активно',
      stateInactive: 'Изключено',
      stateInconsistent: 'Несъгласувано — следващото копие трябва да е пълно',
      stateBroken: 'Веригата е прекъсната — изключете, после включете като нова верига',
      stateSnapshots: 'Винаги включено — делта между снимки',
      stateUnavailable: 'Недостъпно на този диск',
      mechanic: {
        'qcow2-bitmap': 'qcow2 битмап',
        'rbd-snapdiff': 'Diff на Ceph снимки',
        'lvm-thin-delta': 'Делта на thin pool',
        none: 'Няма'
      },
      empty:
        'Няма диск на ВМ. Проследяването се чете по диск: включете го на qcow2 диск или правете снимки на rbd/SAN.',
      chainBroken: 'Веригата е прекъсната',
      chainBrokenText:
        'Прекъсната от {reason}: {bitmaps}. Изключете битмапа (веригата е загубена, следващото копие е пълно), после го включете като нова верига.',
      lineages: 'Епохи',
      epochFrozen: 'замразена в снимка {snapshot}',
      epochLost: 'загубена ({cause})',
      epochRecording: 'записва на главата',
      milestones: 'Етапи (снимки)',
      enable: 'Включи проследяването',
      disable: 'Изключи',
      reset: 'Нулирай',
      changedAreas: 'Променени области',
      denied: 'Нямате разрешение за тази ВМ',
      enableTitle: 'Включи проследяването на промените',
      disableTitle: 'Изключи проследяването на промените',
      resetTitle: 'Нулирай битмапа',
      areasTitle: 'Променени области',
      bitmapName: 'Име на битмапа',
      bitmapNameHint: 'Собствено име: tvirt- и tvbk- са на платформата',
      granularity: 'Гранулярност (байтове)',
      granularityHint: 'Степен на двойката; по подразбиране 65536',
      bitmap: 'Битмап',
      disableHint: 'Премахва битмапа и цялата история на епохите му: следващото копие трябва да е пълно.',
      resetHint: 'Изпразва битмапа — нова база: change ID отпреди нулирането вече не може да се състави.',
      areasFrom: 'От снимка',
      areasTo: 'До снимка',
      areasRun: 'Изчисли',
      areasResult: '{count} променени области, {bytes}',
      areasEmpty: 'Няма променени области между двете снимки',
      areasZero: 'нули',
      areasMore: 'показани първите {shown} от {count}',
      submit: 'Потвърди',
      error: 'Действието по проследяване не успя'
    },
    exports: {
      title: 'Отворени NBD експорти',
      colVm: 'ВМ',
      colDisk: 'Диск',
      colSnapshot: 'Снимка',
      colBitmap: 'Битмап',
      colPhase: 'Фаза',
      colNode: 'Възел',
      colEndpoint: 'Endpoint',
      colExpires: 'Изтича',
      colCreated: 'Отворен',
      colError: 'Грешка',
      phase: {
        preparing: 'Подготовка',
        ready: 'Готов',
        closed: 'Затворен',
        error: 'Неуспешен'
      },
      expiresIn: 'след {minutes} мин',
      expired: 'изтекъл',
      empty: 'Няма експорт. Сесия за четене поднася един диск при една моментна снимка на NBD клиент; сесия за запис запълва недокоснат диск на спряна ВМ. И двете умират при изтичане.',
      endpointHint: 'TLS с CA на клъстера; името на експорта е билетът — умира със сесията',
      closeDenied: 'Нямате разрешение да затваряте експорти на тази ВМ',
      open: 'Отвори NBD експорт',
      openTitle: 'Отвори NBD експорт',
      openDisk: 'Диск',
      openBitmap: 'Битмап (по избор)',
      openBitmapHint:
        'Публикува епохата на този битмап, замразена в тази снимка, като meta-context на променените екстенти (само qcow2 дискове)',
      openTtl: 'Продължителност (минути)',
      openSubmit: 'Отвори',
      openError: 'Експортът не можа да бъде отворен',
      colMode: 'Режим',
      mode: {
        read: 'Четене',
        write: 'Запис'
      },
      caCertificate: 'CA на клъстера',
      caCopy: 'Копирай PEM',
      caDownload: 'Изтегли ca-cert.pem',
      caHint: 'Запишете PEM във ca-cert.pem в частна папка и се свържете с nbds://…?tls-certificates=<папка> (nbdcopy, nbdinfo) или --object tls-creds-x509,dir=<папка>,endpoint=client (qemu-img)',
      caAbsent: 'Сесията не носи CA (няма PKI)',
      openWrite: 'Отвори експорт за запис',
      openWriteTitle: 'Отвори експорт за запис',
      openWriteIntro: 'Дискът трябва да е недокоснат: роден празен, никога незаписван, без моментна снимка; ВМ спряна. Възстановяването ЗАПЪЛВА диска, не го поправя. Докато сесията е отворена, ВМ не стартира, не прави моментна снимка, не се клонира, а дискът не се мести.',
      openWriteSubmit: 'Отвори',
      openWriteError: 'Експортът за запис не можа да бъде отворен',
      openWriteDenied: 'Липсва ви vm.restore.data на тази ВМ',
      openWriteStopped: 'Спрете ВМ, за да отворите експорт за запис',
      fromDescription: 'Създай ВМ от описание',
      fromDescriptionTitle: 'Създай ВМ от описание',
      fromDescriptionIntro: 'Описанието от export-vm-meta се връща като спряна ВМ с празни дискове от описаната геометрия — готова за експортите за запис, диск по диск. Байтовете не минават оттук: носи ги restore-disk (CLI) или NBD клиентът на продукта за резервни копия.',
      fromDescriptionDoc: 'Описание (JSON)',
      fromDescriptionDocHint: 'Поставете документа от export-vm-meta или изберете файла',
      fromDescriptionFile: 'Избери файл…',
      fromDescriptionInvalid: 'Текстът не е JSON документ',
      fromDescriptionName: 'Име на новата ВМ',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Вашият начален scope',
      fromDescriptionStorage: 'Хранилище на дисковете',
      fromDescriptionStorageHint: 'Всеки диск се ражда тук, във формата по подразбиране на хранилището',
      fromDescriptionMetadataStorage: 'Хранилище на метаданните',
      fromDescriptionSameAsStorage: 'Същото като на дисковете',
      fromDescriptionBridge: 'Мост',
      fromDescriptionBridgeHint: 'Без мост или мрежа ВМ се ражда без мрежови карти',
      fromDescriptionNetwork: 'Логическа мрежа (fabric/мрежа)',
      fromDescriptionSubmit: 'Създай',
      fromDescriptionError: 'ВМ не можа да бъде създадена',
      fromDescriptionDone: 'ВМ създадена: {name}',
      fromDescriptionOpen: 'Отвори ВМ',
      fromDescriptionDenied: 'Липсва ви vm.create',
      fromDescriptionStillRunning: 'Създаването още тече: продължаваме да чакаме'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Резервни копия на данните на ВМ',
      titleOnVm: 'Резервни копия на данните',
      empty:
        'Няма копие. Копието пренася дисковете, varstore UEFI и състоянието на vTPM към местоназначение и надживява виртуалната машина.',
      colVm: 'ВМ',
      colCreated: 'Направено на',
      colPhase: 'Резултат',
      colDestination: 'Местоназначение',
      colContains: 'Съдържание',
      colSize: 'Размер',
      colOrigin: 'Произход',
      colMode: 'Вид',
      retentionChip: 'Задържане',
      retentionHint:
        'Задържането на местоназначението може да изтрие това копие, без да пита: то е родено от планиране. Ръчните копия никога не се измитат.',
      policyRemoved: 'Policy премахната: {name}',
      policyRemovedHint:
        'Policy, която планира този backup, вече не съществува: никаква retention не го управлява (никога не се орязва автоматично) — изтрийте го ръчно, когато вече не е нужен.',
      phase: {
        running: 'В ход',
        complete: 'Завършено',
        error: 'Неуспешно'
      },
      origin: {
        manual: 'Ръчно',
        schedule: 'Планирано'
      },
      mode: {
        full: 'Пълно',
        incremental: 'Инкрементално'
      },
      contains: {
        disks: 'Дискове',
        varstore: 'Varstore UEFI',
        vtpm: 'Състояние vTPM',
        snapshots: 'Снимки'
      },
      vmState: {
        stopped: 'ВМ изключена',
        running: 'Работеща ВМ (горещо)'
      },
      artifactClass: { metadata: 'Метаданни', data: 'Данни', secret: 'Тайна' },
      detail: {
        tabOverview: 'Обобщение',
        tabArtefact: 'Артефакт',
        id: 'Идентификатор',
        scope: 'Обхват',
        vmState: 'Състояние на ВМ при копирането',
        pointInTime: 'Момент на данните',
        completedAt: 'Приключено на',
        node: 'Възел, който копира',
        error: 'Грешка',
        path: 'Папка в хранилището',
        checksum: 'sha256 на манифеста',
        secretsExposed: 'Чувствителен материал в открит вид',
        secretsExposedYes: 'Да — местоназначението не криптира',
        secretsExposedNo: 'Не',
        baseBackup: 'Базово копие',
        tabManifest: 'Манифест',
        manifestHint:
          'Откритият указател на артефакта: по един файл на ред заедно с неговия sha256. Папката се проверява и без TVirt — стигат qemu-img, tar и jq.',
        manifestEmpty: 'Манифестът не изброява файлове.',
        manifestError: 'Манифестът не може да се прочете',
        colEntry: 'Файл',
        colClass: 'Клас',
        colSha: 'sha256'
      },
      create: {
        action: 'Копирай сега',
        title: 'Копирай сега',
        submit: 'Стартирай копието',
        destination: 'Местоназначение',
        destinationHint: 'Само местоназначенията, които приемат копия.',
        noDestinations: 'Нито едно местоназначение не приема копия: създайте такова в Система → Checkpoints.',
        contentsHint:
          'Пътуват всички дискове, varstore UEFI и състоянието на vTPM. Последните две са същината: запечатан гост трябва да стартира отново.',
        error: 'Копието не тръгна',
        stillRunning: 'Копието още върви — копирането продължава, дори ако затворите.',
        vmRunning:
          'Машината е {phase}: архивът иска стабилна ВМ — изключена за студеното копиране, работеща за горещото.'
      },
      restore: {
        action: 'Възстанови',
        title: 'Възстанови',
        intro:
          'Възстановяването е необратимо. Изберете накъде се връщат данните: в нова машина или върху първоначалната.',
        modeNewVm: 'Възстанови в НОВА ВМ',
        modeNewVmHint:
          'Не докосва нищо съществуващо — с тази възможност се проверява едно копие. Нов идентификатор и новоизсечени MAC адреси.',
        modeOver: 'Презапиши първоначалната ВМ',
        modeOverHint: 'Унищожава текущите данни на целевата ВМ, без връщане назад. Машината трябва да е изключена.',
        newName: 'Име на новата ВМ',
        newNameHint: 'Трябва да е свободно в целевия обхват.',
        storage: 'Хранилище за дисковете',
        storageHint:
          'Задължително: манифестът записва размера и формата на диска, но никога хранилището, на което е стоял.',
        metadataStorage: 'Хранилище за varstore и vTPM',
        metadataStorageHint: 'Къде се приземяват идентичността UEFI и състоянието на vTPM.',
        sameAsStorage: 'Същото като на дисковете',
        bridge: 'Bridge на хоста',
        bridgeHint:
          'Всяка записана мрежова карта се връща на този bridge с нов MAC. Оставено празно, ВМ се ражда без карти — по-безопасната стойност по подразбиране.',
        overwriteTitle: 'На път сте да презапишете тази ВМ',
        overwriteName: 'Име',
        overwriteId: 'Идентификатор',
        overwriteDisks: 'Дискове, които ще бъдат презаписани',
        overwriteNoDisks: 'Няма дискове.',
        overwriteKeeps:
          'Недокоснати остават идентификаторът, името, обхватът, мрежовите карти и MAC адресите: копието са ДАННИТЕ, конфигурацията е checkpoint.',
        confirmField: 'Име на ВМ',
        confirmHint: 'Напишете {name}, за да потвърдите.',
        targetLoading: 'Четене на целевата ВМ…',
        targetRunning:
          'Целевата ВМ е {phase}: възстановяването презаписва байтовете под госта, затова я иска изключена.',
        targetGone: 'Първоначалната ВМ вече не се чете: остава възстановяването в нова ВМ.',
        onlyComplete: 'Копието е {phase}: възстановяване може само завършено копие.',
        submitNewVm: 'Възстанови в новата ВМ',
        submitOver: 'Презапиши',
        error: 'Възстановяването не тръгна',
        stillRunning: 'Възстановяването още върви — копирането на цели дискове иска време.'
      }
    },
    guest: {
      title: {
        ct: 'Резервни копия на данни на контейнерите',
        app: 'Резервни копия на данни на App'
      },
      tabTitle: 'Резервни копия',
      empty: 'Няма резервни копия. Копието пренася устойчивите данни към дестинация и надживява обекта си.',
      colSubject: {
        ct: 'Контейнер',
        app: 'App'
      },
      colCreated: 'Създадено',
      colPhase: 'Резултат',
      colDestination: 'Дестинация',
      colContains: 'Съдържание',
      colSize: 'Размер',
      colOrigin: 'Произход',
      policyRemoved: 'Policy премахната: {name}',
      policyRemovedHint:
        'Policy, която планира този backup, вече не съществува: никаква retention не го управлява (никога не се орязва автоматично) — изтрийте го ръчно, когато вече не е нужен.',
      phase: {
        running: 'В ход',
        complete: 'Завършено',
        error: 'Неуспешно'
      },
      origin: {
        manual: 'Ръчно',
        schedule: 'Планирано'
      },
      state: {
        stopped: 'Обектът е спрян',
        running: 'Обектът работи (замразен)'
      },
      contains: {
        rootfs: 'Дърво rootfs',
        config: 'Конфигурация',
        volumes: 'Устойчиви томове',
        root: 'Устойчив root'
      },
      artifactClass: {
        metadata: 'Метаданни',
        data: 'Данни',
        secret: 'Тайна'
      },
      create: {
        action: 'Направи копие сега',
        title: 'Ново резервно копие',
        submit: 'Стартирай копието',
        error: 'Копието не стартира',
        destination: 'Дестинация',
        destinationHint: 'Само дестинации, които приемат резервни копия на данни.',
        noDestinations:
          'Никоя дестинация не приема резервни копия на данни: добавете „Резервни копия на данни“ към дестинация.',
        hint: {
          ct: 'Пътува цялото дърво rootfs, вярно (числови собственици, xattrs, ACL), плюс декларираната конфигурация в манифеста. Работещ контейнер се ЗАМРАЗЯВА за цялото пакетиране: crash-consistent копие, декларирано.',
          app: 'Пътуват САМО устойчивите томове (и устойчивият root), плюс конфигурацията в манифеста. Ефимерното е изключено по ратификация и манифестът го назовава; env стойностите, декларирани тайни, не пътуват.'
        },
        stillRunning: 'Копието още тече — пакетирането на цели дървета отнема време.'
      },
      detail: {
        tabOverview: 'Преглед',
        tabManifest: 'Манифест',
        id: 'Идентификатор',
        scope: 'Обхват',
        state: 'Състояние при копието',
        pointInTime: 'Данни към момента',
        completedAt: 'Приключено',
        node: 'Възел, който копира',
        error: 'Грешка',
        path: 'Папка в хранилището',
        checksum: 'sha256 на манифеста',
        manifestHint:
          'Индексът на артефакта: по един запис на файл със sha256 — без хешовете „копието е там“ е акт на вяра.',
        manifestError: 'Манифестът не може да бъде прочетен',
        manifestEmpty: 'Няма артефакти в манифеста.',
        colEntry: 'Файл',
        colClass: 'Клас',
        colSha: 'sha256',
        excluded: 'Изключено по ратификация (не пътува)',
        secretKeys: 'Пропуснати тайни env ключове (#307) — въведете ги отново след възстановяване'
      },
      restore: {
        action: 'Възстанови',
        title: 'Възстановяване',
        submit: 'Възстанови',
        error: 'Възстановяването не стартира',
        stillRunning: 'Възстановяването още тече — разопаковането на цели дървета отнема време.',
        onlyComplete: 'Копието е {phase}: само завършено копие може да възстановява.',
        asNew: {
          ct: 'В НОВ контейнер — не унищожава нищо: жестът, с който се проверява копие',
          app: 'В НОВО App — не унищожава нищо: жестът, с който се проверява копие'
        },
        over: {
          ct: 'ВЪРХУ изходния контейнер — цялото дърво rootfs се заменя',
          app: 'ВЪРХУ изходното App — съдържанието на всеки устойчив том се заменя'
        },
        name: 'Име на новия обект',
        storage: 'Хранилище',
        storageHint: 'Къде кацат възстановените данни — манифестът никога не записва изгубения pool.',
        storageDeclared: 'Хранилищата, декларирани в манифеста',
        bridge: 'Мост на хоста',
        bridgeHint:
          'Всяка регистрирана карта се връща на този мост с нов MAC. Празно = ражда се несвързан, най-сигурното по подразбиране.',
        node: 'Възел',
        nodeHint: 'Членът, на който App се преражда: възелът е клъстерна идентичност и никога не идва от манифеста.',
        secretKeysWarning:
          'Env стойностите, декларирани тайни, не пътуват в копието: прероденото копие ги иска въведени отново (логът на задачата назовава ключовете).',
        overInventory: 'На път сте да презапишете този обект',
        confirmType: 'Въведете {name} за потвърждение',
        targetGone: 'Изходният обект вече не може да бъде прочетен: остава възстановяването като нов.',
        targetLoading: 'Четене на целевия обект…',
        targetRunning: 'Целевият обект работи: възстановяването заменя байтовете под госта и го иска спрян.'
      }
    }
  }
}
